export { Alert } from "@mantine/core";
export type { AlertProps } from "@mantine/core";
export { alertOverrides } from "./Alert.config";
